import { Auth } from "@aws-amplify/auth";


export const signOut = ({ successCallback = () => { } }) => {
    Auth
        .signOut({ global: true })
        .then(successCallback)
        .catch(e => e.message === "Access Token has been revoked" && Auth.signOut())
};